<template>
  <div class="bookIntro">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox
        @query="queryList"
        searchText1="搜索"
        placeholder="请输入图书名称"
        v-model:inputValue="mydata.form.search"
      ></inputBox>
    </div>

    <!-- 学科筛选按钮 -->
    <div class="subject-button">
      <subjectButton
        @change="change1"
        :filterButton="mydata.filterButton1"
        style="margin-bottom: 10px"
        :key="mydata.testKey0"
      ></subjectButton>
      <subjectButton
        @change="change2"
        :filterButton="mydata.filterButton2"
        style="margin-bottom: 10px"
        :key="mydata.testKey1"
      ></subjectButton>
      <!-- <subjectButton
        :filterButton="mydata.filterButton3"
        @change="change3"
      ></subjectButton> -->
      <subjectButton2
        :key="mydata.testKey2"
        :filterButton="mydata.filterButton3"
        @change="change3"
      ></subjectButton2>
    </div>
    <div class="tests-Card">
      <modelTestsCard
        v-for="(item, index) in mydata.bookArr"
        :key="index"
        :info="item"
        path="/layout/list/booksDetails"
      ></modelTestsCard>
      <!-- 空白内容组件 -->
      <glEmpty v-if="mydata.bookArr.length === 0" marginBottom="20px"></glEmpty>
    </div>

    <!--分页 -->
    <div class="gl-pagination" style="margin-top:14px;">
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- <bottomBar></bottomBar> -->
  </div>
</template>

<script>
// 是否来自其他模块
let fromOtherModule = false
// 缓存组件
import { defineComponent } from "vue"
export default defineComponent({
  name: 'addedServices',
  beforeRouteEnter(to,from,next){    
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (from.path !== '/layout/list/booksDetails') {
      fromOtherModule = true
      // console.log('来自其他模块');      
    }
    next()
  }
});
</script>

<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";

import inputBox from "@/components/inputBox/index.vue";

import modelTestsCard from "@/components/modelTestsCard/index.vue";

import subjectButton from "@/components/subjectButton/index.vue";

// import bottomBar from "@/components/bottomBar/index.vue";
import { useRouter , useRoute } from "vue-router";

import { reactive , onActivated } from "vue";
import subjectButton2 from "@/components/subjectButton2/index.vue";
//获取图书列表接口
import { bookList } from "@/api/addedServices/index.js";
import { bookScreeningCondition } from "@/api/dictionary/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  //筛选按钮
  filterButton1: {
    title: "版本",
    filter: JSON.parse(localStorage.getItem("book_version_years")) ?? [],
  },
  filterButton2: {
    title: "学段",
    filter: JSON.parse(localStorage.getItem("book_grade")) ?? [],
  },
  filterButton3: {
    title: "学科",
    // filter: JSON.parse(localStorage.getItem("book_subject")) ?? [],
    filter: [],
  },
  testKey0: new Date().getTime() - Math.random()*10,
  testKey1: new Date().getTime() - Math.random()*100,
  testKey2: new Date().getTime() - Math.random(),
  form: {
    // column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询

    grade_id: "", // 学段
    subject_id: "", //学科
    version_years: "", //版本
  },

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 20, // 每页条数
    total: 0, // 总的条数
  },

  bookArr: [], //图书列表

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
});



onActivated(()=>{
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    //筛选按钮
    mydata.filterButton1= {
      title: "版本",
      filter: JSON.parse(localStorage.getItem("book_version_years")) ?? [],
    }
    mydata.filterButton2= {
      title: "学段",
      filter: JSON.parse(localStorage.getItem("book_grade")) ?? [],
    }
    mydata.filterButton3= {
      title: "学科",
      filter: [],
    }
    
    mydata.testKey0= new Date().getTime() - Math.random()*10
    mydata.testKey1= new Date().getTime() - Math.random()*100
    mydata.testKey2= new Date().getTime() - Math.random()
    mydata.form= {
      search: "", // 搜索查询
      grade_id: "", // 学段
      subject_id: "", //学科
      version_years: "", //版本
    }
    mydata.pageObj= {
      currentPage: 1, // 当前页数
      pageSize: 20, // 每页条数
      total: 0, // 总的条数
    }
    mydata.bookArr= [], //图书列表
    mydata.userInfo= JSON.parse(localStorage.getItem("userInfo")) ?? {} //用户信息
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getSubject();
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getData()
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false

  if (localStorage.getItem('v') !== null) {
    // 分页变成第一页
    mydata.pageObj.currentPage = 1
    mydata.form.search = localStorage.getItem('v') // 获取本地存储并且赋值
    localStorage.removeItem('v')  // 赋值后立刻删除本地存储内容
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getSubject();
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getData()
    // getData()
    // 拿到query参数并且赋值之后，就进行二次跳转，把query参数删除了，避免详情页面后退到列表页面的时候，再次拿到query参数并且赋值
    // router.push({
    //   path:"/layout/list/addedServices"
    // })
  }
})




function getSubject() {
  // 图书列表的搜索条件
  bookScreeningCondition({ grade_id: mydata.form.grade_id }).then((res) => {
    // 学科
    mydata.filterButton3.filter = res.data.subject.map((item) => {
      return {
        label: item.name,
        name: item.id,
      };
    });
  });
}

// getSubject();

// 版本单选改变事件
function change1(val) {
  // 赋值
  mydata.form.version_years = val;
  // 查询
  getData();
}

// 学段单选改变事件
function change2(val) {
  // 赋值
  mydata.form.grade_id = val;
  // 学科选择全部
  mydata.form.subject_id = "";
  // 图书列表的搜索条件
  bookScreeningCondition({ grade_id: mydata.form.grade_id }).then((res) => {
    // 学科
    mydata.filterButton3.filter = res.data.subject.map((item) => {
      return {
        label: item.name,
        name: item.id,
      };
    });
    mydata.testKey2 = new Date().getTime() - Math.random();
    // 查询
    getData();
  });
}

// 学科单选改变事件
function change3(val) {
  // 赋值
  mydata.form.subject_id = val;
  // 查询
  getData();
}

// 查询列表
function queryList(dict, inputValue) {
  // console.log(1);
  // 分页变成第一页
  mydata.pageObj.currentPage = 1
  // 赋值
  mydata.form.search = inputValue;
  // 获取页面数据
  getData();
}

// 获取页面数据
function getData() {
  // 调用接口
  bookList(mydata.userInfo?.jwt, {
    ...mydata.form,
    page: mydata.pageObj.currentPage,
    psize: mydata.pageObj.pageSize,
  }).then((res) => {
    // console.log(res, "图书列表");
    mydata.bookArr = res.data.list;
    mydata.pageObj.total = res.data.count;
  });
}
// getData();

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  getData();
}
</script>

<style scoped lang="scss">
.bookIntro {
  background-color: #f9f9f9;
  // padding-bottom: 40px !important;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

 
  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
      .box2 {
        display: none;
      }
    }
  }

  .subject-button {
    width: 375px !important;
    // height: 397px;
    // border: 1px solid rgb(0, 115, 255);
    background-color: #ffffff;
    margin: 0 auto;
    margin-top: 16px;
    padding: 16px 0px;
    overflow: hidden;
    // border-radius: 8px;

    :deep(.el-icon.my-icon-arrow){
      display:none;
    }
  }

  .tests-Card {
    width: 343px !important;
    // height: 397px;
    // border: 1px solid rgb(217, 255, 0);
    margin: 0 auto;
    margin-top: 16px;
    // margin-bottom: 45px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    // align-content: space-between; //行间距 （控制折行后的行间距）
    /* flex-start
       flex-end;     
       center;       
       space-between;
       space-around; */
    .test-card {
      // border:1px solid red;
      // margin-right: 20px;
      margin-bottom: 10px;
    }
    .test-card:nth-of-type(2n) {
      // border:1px solid red;
      margin-right: 0px;
    }
  }

  //调整分页的 margin-top
  :deep(.gl-pagination) {
    margin-top: 20px;
  }

  //////////分页
  // .paging {
  //   margin: 0 auto;
  //   display: flex;
  //   // justify-content: center;

  //   :deep(.el-button.is-plain) {
  //     margin-left: 24px;
  //   }
  // }
  // //最左边的箭头
  // :deep(.btn-prev.is-first) {
  //   margin-right: 12px;
  // }
  // //每个页
  // :deep(.number) {
  //   margin-right: 12px;
  //   // color:#BBBDBF;
  // }
  // //省略号
  // :deep(.more.btn-quicknext.el-icon) {
  //   margin-right: 12px;
  //   background-color: #f9f9f9;
  // }

  // .demo-pagination-block + .demo-pagination-block {
  //   margin-top: 10px;
  // }
  // .demo-pagination-block .demonstration {
  //   margin-bottom: 16px;
  // }

  /* 
  
  
  
  【多选框那一快的逻辑不要改】
  就是现在的逻辑

  要不选择某几个课程
  要不选择全部课程【那现在是点击全部是取消的意思，并不是全部都选】

  不是抖音上面  你树洞额那个样子
  【多选框那一快的逻辑不要改】


  好了  就这些



  
  */
}
</style>
